import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { TopBarSlimThemes } from '../TopBarSlimEnums';
import { Link, Typography } from '@sm/wds-react';

const COPY = defineMessages({
  MESSAGE: {
    id: 'HasOverageTeamTopBarSlim.message',
    defaultMessage: 'To add users to your team, { ctaText }',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'HasOverageTeamTopBarSlim.ctaText',
    defaultMessage: 'Pay now',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
  BOLD_PREFIX: {
    id: 'HasOverageTeamTopBarSlim.prefix',
    defaultMessage: 'Looks like you have an unpaid invoice.',
    description: '[Type: Header][Vis.: low] - Top bar slim prefix',
  },
});

export const HasOverageTeamTopBarSlim: React.FC = () => {
  const url = createURL('/billing/history/', {
    ut_source: 'topbar',
    ut_source2: 'has_overage_group_members',
  });

  // The CTA is displayed as part of the message.
  const ctaText = (
    <Link className="wds-display--inline-block" href={url} target="_blank">
      <Typography className={`sm-top-bar-slim--warning__cta-text`}>
        {t(COPY.CTA_TEXT)}
      </Typography>
    </Link>
  );

  return (
    <TopBarSlim
      message={t(COPY.MESSAGE, { ctaText })}
      theme={TopBarSlimThemes.warning}
      prefix={t(COPY.BOLD_PREFIX)}
    />
  );
};

export default HasOverageTeamTopBarSlim;
